"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddress = exports.normalizeAddress = void 0;

var _tslib = require("tslib");

var _context = require("../context");

var _toString2 = _interopRequireDefault(require("lodash/toString"));

var _map2 = _interopRequireDefault(require("lodash/map"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var normalizeAddress = function normalizeAddress(address) {
  return Object.assign.apply(Object, (0, _tslib.__spreadArrays)([{}], (0, _map2["default"])(address, function (value, key) {
    var _a;

    return key === 'zip' ? {
      zipCode: (0, _toString2["default"])(value)
    } : (_a = {}, _a[key] = (0, _toString2["default"])(value), _a);
  })));
};

exports.normalizeAddress = normalizeAddress;

var useAddress = function useAddress() {
  var dispatch = (0, _context.useAddressDispatch)();
  var state = (0, _context.useAddressState)();

  var setAddress = function setAddress(addressState) {
    addressState && dispatch({
      type: "SET"
      /* SET */
      ,
      payload: {
        delivery: addressState.delivery ? normalizeAddress(addressState.delivery) : state.delivery,
        pickup: addressState.pickup ? normalizeAddress(addressState.pickup) : state.pickup
      }
    });
  };

  var setPickupAddress = function setPickupAddress(pickupAddress) {
    setAddress({
      pickup: pickupAddress
    });
  };

  var setDeliveryAddress = function setDeliveryAddress(deliveryAddress) {
    setAddress({
      delivery: deliveryAddress
    });
  };

  var unsetAddress = function unsetAddress() {
    dispatch({
      type: "UNSET"
      /* UNSET */

    });
  };

  return {
    addresses: state,
    deliveryAddress: state.delivery,
    pickupAddress: state.pickup,
    setAddress: setAddress,
    setDeliveryAddress: setDeliveryAddress,
    setPickupAddress: setPickupAddress,
    unsetAddress: unsetAddress
  };
};

exports.useAddress = useAddress;